import { getMenuTree } from "@/api/common"; //接口请求
import { constantRoutes } from "@/router";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import { currentSysUserInfo } from "@/api/common";
// 获取菜单树结构
export let titlfd = "ffffffff";
export async function _getPermissionMenuTreeAllData() {
   // 获取供应商ID
  let userInfo = await currentSysUserInfo()
  let { supplierId } = userInfo.data
  // return
  // if (store.state.user.adminType == 1) {
  //   return;
  // }

  let data = [];
  let constantRoutesIndex = 0;
  let routerTitle = "城投助农";
  //在constantRoutes中对应路由的下标
  constantRoutes.forEach((item, index) => {
    if (item.meta && item.meta.title == "城投助农") {
      constantRoutesIndex = index;
    }
  });
  let arr = [{ name: routerTitle, index: constantRoutesIndex }];
  let res = {};
  // let res = await getMenuTree(); // 获取菜单
  // data=[{
  //   name:'总公司管理',
  //   children:res.data
  // }]

  if (supplierId) {
    // Mock Menu Tree
    res = {
      data: [
        {
          label: "城投助农",
          name: "城投助农",
          status: "Y",
          children: [
            {
              label: "订单管理",
              name: "订单管理",
              status: "Y",
              children: [
                {
                  label: "客户订单",
                  name: "客户订单",
                  status: "Y"
                },{
                  label: "退货退款",
                  name: "退货退款",
                  status: "Y"
                }
              ]
            }
          ]
        }
      ]
    };
  }

  res.data.forEach(item => {
    if (item.name == routerTitle) {
      data.push(item);
    }
  });
  if (data.length == 0) {
    // Message({
    //   type: "warning",
    //   message: "您没有该系统权限!"
    // });
    constantRoutes[constantRoutesIndex].children = [];
    return;
  }
  localStorage.setItem("ms-main-routerTree", JSON.stringify(data[0]));
  arr.forEach(item => {
    data.forEach(item2 => {
      if (item.name == item2.name) {
        setRouter(item.index, item2);
      }
    });
  });
}

//设置路由
function setRouter(routerIndex, itemData) {
  let allRouter = constantRoutes[routerIndex];
  // let allRouter = this.$router.options.routes;
  let postData = itemData;
  let newRouter = [];
  // console.log('子集')
  // console.log(postData.children)
  // console.log(allRouter.children)
  postData.children.forEach((item, index) => {
    allRouter.children.forEach(item2 => {
      if (!findItem(postData.children, item2)) {
        item2.hidden = true;
        //  item.hidden=true
      }
      if (item2.meta && item2.meta.title == item.name) {
        item2.hidden = false;
        item2.index = index; //给对应顺序的路由加上index 方便排序
        let copyItem = JSON.parse(JSON.stringify(item2));
        newRouter.push(copyItem);
        // console.log(newRouter[newRouter.length - 1])
        newRouter[newRouter.length - 1].children = [];
        sortChildren(
          item2.children,
          item.children,
          newRouter[newRouter.length - 1].children
        );
      }
    });
  });

  // allRouter.children.forEach((item, index) => {
  //     newRouter.forEach((item2, index2) => {
  //         if (item.path == item2.path) {
  //             item.index = index2
  //         }
  //     });
  // });
  sortItem(allRouter);
  // allRouter.children.sort((a, b) => { return a.index - b.index });
  console.log(newRouter);
  console.log(allRouter);
}

//已index为准对children数组进行排序
function sortItem(data) {
  data.children.sort((a, b) => {
    return a.index - b.index;
  });
  data.children.forEach(item => {
    if (item.children && item.children.length > 0) {
      sortItem(item);
    }
  });
}

//查找路由数组中是否有这个路由对象
function findItem(data, data1) {
  let have = false;
  data.forEach(item3 => {
    if (data1.meta && item3.name == data1.meta.title) {
      have = true;
    }
  });
  if (!have) {
    // data1.hidden=true
  }
  return have;
}

//根据树形结构重排路由顺序 router 路由 data 树形结构
function sortChildren(router, data, newRouter) {
  data.forEach((item, index) => {
    router.forEach((item2, index2, arr) => {
      if (!findItem(data, item2)) {
        item2.hidden = true;
        //   item2.hidden=true
      }
      let copyItem = JSON.parse(JSON.stringify(item2));
      if (item2.meta && item2.meta.title == item.name) {
        item2.hidden = false;
        item2.index = index;
        newRouter.push(copyItem);
        newRouter[newRouter.length - 1].children = [];
        if (item.children && item.children.length > 0 && item2.children) {
          sortChildren(
            item2.children,
            item.children,
            newRouter[newRouter.length - 1].children
          );
        }
      } else if (index == data.length - 1 && !findItem(newRouter, item2)) {
        item.index = 999;
        // item.hidden=true
        // copyItem.hidden=true
        newRouter.push(copyItem);
        newRouter[newRouter.length - 1].children = [];
      }
    });
  });
  return newRouter;
}

//按钮是否有权限
let haveButton = false;
//查找按钮是否有权限 routerName当前页面的this.$route.meta.title buttonName 按钮名称
export function getButton(routerName, buttonName) {
  if (store.state.user.adminType == 1) {
    return true;
  }
  return true;
  haveButton = false;
  if (localStorage.getItem("ms-main-routerTree")) {
    let routerTreeData = JSON.parse(localStorage.getItem("ms-main-routerTree"));
    let a = findButton(routerTreeData, routerName, buttonName);
  }
  // console.log(haveButton)
  return haveButton;
}
//查找权限路由(routerTree)对应页面(routerName)里的button(buttonName)是否存在
function findButton(routerTree, routerName, buttonName) {
  if (routerTree.name == routerName) {
    routerTree.children.some(item => {
      if (item.isBtn == 1 && item.name == buttonName) {
        haveButton = true;
      }
    });
  } else if (routerTree.children) {
    routerTree.children.forEach(item => {
      findButton(item, routerName, buttonName, haveButton);
    });
  }
}
